import type React from 'react';
import { Checkboxes } from 'mui-rff';
import { Checkbox, type CheckboxProps } from '@mui/material';
import { useForm, useFormState } from 'react-final-form';
import get from 'lodash/get';

export type CheckboxCellProps = {
  accessor: string;
};

export const CheckboxCell = ({ accessor }: CheckboxCellProps) => {
  return <Checkboxes formControlLabelProps={{ sx: { margin: 0 } }} name={accessor} data={{ label: '', value: true }} />;
};

type HeaderCheckboxCellProps = CheckboxProps & {
  rowsCount: number;
  formTableName: string;
  accessor: string;
};

export const HeaderCheckboxCell = ({ rowsCount, formTableName, accessor, ...rest }: HeaderCheckboxCellProps) => {
  const { values } = useFormState();
  const form = useForm();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    for (let i = 0; i < rowsCount; i++) {
      form.change(`${formTableName}[${i}].${accessor}`, e.target.checked);
    }
  };

  const selectedCount = new Array(rowsCount)
    .fill(0)
    .filter((_, i) => get(values, `${formTableName}[${i}].${accessor}`)).length;
  return (
    <Checkbox
      sx={{ margin: 0 }}
      indeterminate={selectedCount > 0 && selectedCount < rowsCount}
      checked={rowsCount > 0 && selectedCount === rowsCount}
      onChange={handleChange}
      {...rest}
    />
  );
};
